var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.186,
    height: 25.433,
    viewBox: "0 0 32.186 25.433",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2062",
    "data-name": "Path 2062",
    d: "M20.188,29.933a1.412,1.412,0,0,1-1-.413l-6.776-6.776a1.412,1.412,0,0,1,2-2l5.777,5.777L41.775,4.914a1.412,1.412,0,1,1,2,2L21.186,29.519a1.412,1.412,0,0,1-1,.414Z",
    transform: "translate(-12 -4.5)",
    fill: "#00db6e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.756b7c0adf21c48bf54823222ab5bc19.svg";
export { ForwardRef as ReactComponent };